import React from "react";
import BookingInfoCard from "@/components/booking/bookingInfoCard";
import DateTimeSelectionSlotGrid from "@/components/booking/dateTimeSelectionSlotGrid";
import ProviderScrollableCarousel from "@/components/booking/providerScrollableCarousel";
import { useClientBookingContext } from "@/contexts/clientBookingContext";
import useBookingDateTimeSelection from "@/hooks/booking/useBookingDateTimeSelection";

export default function BookingDateTimeSelectionWithProvider() {
  const {
    medspaData,
    date,
    setDate,
    customizationEnabled,
    customizationPrimaryColor,
    customizationTextColor,
    selectedProvider,
    eligibleProviders,
    providers,
    setSelectedProvider,
    timeSlot,
    selectiveBookingLink,
  } = useClientBookingContext();

  const {
    bookingAvailableDates,
    timeSlotsForSelectedDate,
    handleTimeSlotSelection,
    handleMonthChange,
    loading,
  } = useBookingDateTimeSelection();

  const primaryColor = customizationEnabled
    ? customizationPrimaryColor
    : undefined;

  const textColor = customizationEnabled ? customizationTextColor : undefined;

  return (
    <BookingInfoCard>
      <ProviderScrollableCarousel
        selectedProvider={selectedProvider}
        providers={providers}
        eligibleProviders={eligibleProviders}
        setSelectedProvider={setSelectedProvider}
        customizationPrimaryColor={primaryColor}
        customizationTextColor={textColor}
      />
      <DateTimeSelectionSlotGrid
        selectedTimeSlot={timeSlot}
        onDateChange={setDate}
        onTimeSlotSelect={handleTimeSlotSelection}
        onMonthChange={handleMonthChange}
        date={date}
        bookingAvailableDates={bookingAvailableDates}
        timeSlots={timeSlotsForSelectedDate}
        medspaTimeZone={medspaData.timezone}
        medspaName={medspaData.name}
        maximumAdvanceBookingHours={
          medspaData.configuration.maximumAdvanceBookingHours
        }
        customizationPrimaryColor={primaryColor}
        customizationTextColor={textColor}
        loading={loading}
        startDateSelectiveBookingLink={selectiveBookingLink?.startDate}
        endDateSelectiveBookingLink={selectiveBookingLink?.endDate}
      />
    </BookingInfoCard>
  );
}
